<h6 class="bxt-table-title">SMS Sent</h6>
<div class="header" *ngIf="showCreate">
    <div class="new">
        <button class="btn-bx-primary" (click)="createNew()">Create New</button>
    </div>
</div>

<div class="panel panel-white">
    <div class="panel-body">
        <div class="table-responsive margin-top-15" *ngIf="rows?.length! > 0; else noRecords">
            <div class="table-wrapper">
                <ngx-datatable
                    #myTable
                    class="material bxt-table"
                    [rowHeight]="'auto'"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [rows]="rows"
                    [columnMode]="'force'"
                    [count]="page?.totalElements!"
                    [loadingIndicator]="isLoading"
                    [externalPaging]="true"
                    (page)="setPage($event)"
                    (sort)="sortTable($event)"
                    [limit]="page?.size"
                    [scrollbarV]="true"
                    [scrollbarH]="layoutService.isMobile()"
                    [virtualization]="false">
                    <ngx-datatable-column name="Sent" prop="dateSent">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.dateSent | date: 'medium' }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Mobile" prop="mobileNumber"></ngx-datatable-column>
                    <ngx-datatable-column
                        name="Message"
                        prop="decodedMessage"
                        [sortable]="false"
                        [cellClass]="'wrap-column'"></ngx-datatable-column>

                    <ngx-datatable-footer>
                        <ng-template
                            ngx-datatable-footer-template
                            let-rowCount="rowCount"
                            let-pageSize="pageSize"
                            let-selectedCount="selectedCount"
                            let-curPage="curPage"
                            let-offset="offset"
                            let-isVisible="isVisible">
                            <app-table-footer-paging *ngIf="rowCount > 10" [size]="page?.size" (pageLimitChange)="pageLimit($event)">
                            </app-table-footer-paging>

                            <datatable-pager
                                [pagerLeftArrowIcon]="'datatable-icon-left'"
                                [pagerRightArrowIcon]="'datatable-icon-right'"
                                [pagerPreviousIcon]="'datatable-icon-prev'"
                                [pagerNextIcon]="'datatable-icon-skip'"
                                [page]="curPage"
                                [size]="pageSize"
                                [count]="rowCount"
                                [hidden]="!(rowCount / pageSize > 1)"
                                (change)="myTable.onFooterPage($event)">
                            </datatable-pager>
                        </ng-template>
                    </ngx-datatable-footer>
                </ngx-datatable>
            </div>
        </div>
        <ng-template #noRecords>
            <div class="col-xs-12 text-center">
                <h2 class="margin-top-30 margin-bottom-30">
                    No SMS messages were found.
                    <a *ngIf="showCreate" (click)="createNew()">Create a new SMS</a>
                </h2>
            </div>
        </ng-template>
    </div>
</div>
